import { isReservedPathSegment } from "./reservedPathSegments";

const getOrganization = () => {
  const path = window.location.pathname;
  const organization = path.split("/")[1];

  if (isReservedPathSegment(organization)) {
    return "";
  }

  return organization;
};

export default getOrganization;
